import {Box} from "@mui/system";
import MsgDataSource from "../Utilities/MsgDataSources/MsgDataSource";
import styles from "../organizationMainStyles";
import {getAccessibilityMode, getLabel} from "../Utilities/organizationSettingsUtils";
import {fragmentId} from "../Utilities/organizationSettingsConstants";
import _ from "lodash";
import NoDataView from "../EmptyStates/NoDataView";
import React from "react";
import MsgDataSourcesEmptyState from "../EmptyStates/MsgDataSourcesEmptyState";
import useGetMsgDataSources from "../hooks/useGetMsgDataSources";
import {msgSource} from "_constants";

export default function MsgDataSources({organizationId}) {
    const label = getLabel(fragmentId.MSG_DATA_SOURCES);
    let {msgSources, loading} = useGetMsgDataSources(organizationId);
    const mode = getAccessibilityMode();
    const supportedMsgSources = [msgSource.ZENDESK, msgSource.GORGIAS];
    msgSources = _.filter(msgSources, item => supportedMsgSources.includes(_.toString(item?.name).toLowerCase()));

    if(_.isEmpty(organizationId) && _.isEmpty(msgSources)) {
        return <NoDataView />
    }

    if(loading) {
        return (
            <Box sx={styles.sectionWrapper}>
                <MsgDataSourcesEmptyState/>
            </Box>
        )
    }

    if(!loading && _.isEmpty(msgSources)) {
        return <NoDataView description={'No data found'} />
    }

    return (
        <Box sx={styles.sectionWrapper}>
            {
                msgSources && msgSources?.map((msgSource) =>
                    <MsgDataSource
                        key={msgSource.id}
                        msgSource={msgSource}
                        mode={mode}
                        label={label}
                    />
                )
            }
        </Box>
    )
}